module.exports = __webpack_public_path__ + "陈茂波-eef852cc.png";